import { render, staticRenderFns } from "./fourColumns.vue?vue&type=template&id=7c0476c6"
import script from "./fourColumns.vue?vue&type=script&lang=js"
export * from "./fourColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports